export function getSetting(state) {
    return state.SettingReducer.setting;
}
